import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { ClientesBackOfficeButtonComponent } from './clientes-backoffice-button.component';

@NgModule({
  imports: [CommonModule, NzButtonModule, NzTooltipModule],
  declarations: [ClientesBackOfficeButtonComponent],
  exports: [ClientesBackOfficeButtonComponent],
})
export class ClientesBackOfficeButtonModule {
}
